package xim.poc.game.configuration.v0.tactics

import xim.math.Vector2f
import xim.poc.MenuStacks
import xim.poc.UiElementHelper
import xim.poc.game.ActorState
import xim.poc.game.ActorStateManager
import xim.poc.game.configuration.v0.GameV0
import xim.poc.game.event.ActorAttackedEvent
import xim.poc.game.event.ActorHealedEvent
import xim.poc.game.event.AttackDamageType
import xim.poc.game.event.Event
import xim.poc.gl.PortraitBufferManager
import xim.poc.ui.ShiftJis
import xim.resource.UiElement
import xim.resource.UiFlipMode
import kotlin.math.roundToInt

object TacticsSkillSpeculation {

    fun draw(primaryTarget: ActorState, events: List<Event>) {
        UiElementHelper.enqueueDraw { drawInternal(primaryTarget, events) }
    }

    private fun drawInternal(primaryTarget: ActorState, events: List<Event>) {
        val lines = ArrayList<String>()

        for (event in events) {
            if (event is ActorAttackedEvent) {
                lines += toString(event) ?: continue
            } else if (event is ActorHealedEvent) {
                lines += toString(event) ?: continue
            }
        }

        if (lines.isEmpty()) { return }

        val message = "Potential skill outcome:\n" + lines.joinToString("\n")
        val messageLines = (lines.size + 1).coerceAtLeast(3)

        val menuName = when {
            messageLines == 3 -> "menu    iteminfo"
            messageLines <= 9 -> "menu    item${messageLines}inf"
            else -> "menu    item${messageLines}in"
        }

        val menuPosition = UiElementHelper.drawMenu(menuName, menuStacks = MenuStacks.LogStack) ?: return
        UiElementHelper.drawString(message, offset = menuPosition + Vector2f(x = 46f, y = 8f))

        val portrait = PortraitBufferManager.getTakenPhoto(primaryTarget.id) ?: return
        val portraitElement = UiElement.basicSquare(portrait.name, size = 32, uvHeight = 64, uvWidth = 64, flipMode = UiFlipMode.Vertical)

        val customBorder = primaryTarget.getUnitConfig()?.internalQuality ?: 0

        UiElementHelper.drawCustomBorder(position = menuPosition + Vector2f(8f, 12f), customBorder = customBorder)
        UiElementHelper.drawUiElement(portraitElement, position = menuPosition + Vector2f(10f, 12f))
    }

    private fun toString(event: ActorAttackedEvent): String? {
        if (event.damageType == AttackDamageType.StatusOnly) { return null }

        val attacker = ActorStateManager[event.sourceId] ?: return null
        val target = ActorStateManager[event.targetId] ?: return null

        val hitChance = if (event.damageType == AttackDamageType.Physical) {
            GameV0.getPhysicalHitChance(attacker, target)
        } else {
            1f
        }

        val hitString = "(${(hitChance * 100f).roundToInt()}% Hit)"
        return "${ShiftJis.solidSquare}${target.name}${ShiftJis.rightArrow}${ShiftJis.colorInvalid}-${event.damageAmount.sum()}${event.attackEffects.damageResource}${ShiftJis.colorClear}  $hitString"
    }

    private fun toString(event: ActorHealedEvent): String? {
        val target = ActorStateManager[event.targetId] ?: return null
        return "${ShiftJis.solidSquare}${target.name}${ShiftJis.rightArrow}${ShiftJis.colorItem}+${event.amount}${event.healType}${ShiftJis.colorClear}."
    }

}